module.exports = "/images/payPal.svg?b2f35f94c9ebc2144c01f4fd5c06d2e4";